import imgPageNotFound from "../../assests/images/errorHandler/pageNotFoundImg.webp"
import { useRouteMatch, useHistory } from "react-router-dom";

const PageNotFound = () => {

    const history = useHistory();
    const moveToRoot = () => {
        history?.goBack();
      };

    return (
        <div class="container-fluid my-4 p-0 d-flex justify-content-center align-items-center">
            <div class="col-lg-6 d-flex flex-column  " >
                <div class="d-flex flex-column">
                       <img src={imgPageNotFound} alt="pageNotFound" />
                       <div class="text-center">
                       <h1 class="roboto fw-bold ">Page not found</h1>
                       <p class="roboto fs-4">Sorry! The page you are looking for is not available. </p>
                       </div>
                
                </div>
                <div class="d-flex my-1 align-self-center mb-4">
                    <button onClick={() => moveToRoot()} variant="contained" class="primaryButton ">
                     Go Back
                        </button>
                     </div>
                
            </div>
        </div>

    )
}


export default PageNotFound